var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"crly-a-common-search-keyword-btn crly-icon",on:{"click":_vm.clickSearchBtn}},[_c('label',[_vm._v(_vm._s(_vm.$t("search.keyword.searchBtn")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }